<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20V18H12V20H10M10 4V2H12V4H10M18 12V10H20V12H18M18 16V14H20V16H18M14 20V18H16V20H14M18 20V18H20V20H18M6 20V18H8V20H6M6 4V2H8V4H6M18 8V6H20V8H18M18 4V2H20V4H18M14 4V2H16V4H14M2 20V2H4V20H2Z"
      fill="currentColor"
    />
  </svg>
</template>
